export const INDUSTRY_OPTIONS = [
  "Airports",
  "Asset Maintenance",
  "Communication",
  "Consulting",
  "Construction",
  "Electric",
  "Gas",
  "Highways",
  "Insurance",
  "Property",
  "Rail",
  "Streetworks",
  "Technology",
  "Traffic Management",
  "Water",
  "Other",
] as const;
